import React, { useState } from "react";
import LocationRepositoryTabs from "./location_repository_tabs";
import CommonSearchFiled from "../../../components/commonSearchField";
import MyPagination from "../../../components/pagination/pagination";
import StringUtils from "../../../utils/string_utils";
import LocationRepositoryBody from "./location_repository_body";
import {footerStyles} from "../../../components/style/common_style";

const LocationRepositoryPage = () => {


  const [activeTab, setActiveTabs] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [loactionCount, setLocationCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPage] = useState(1);
  const [isStart, setIsStart] = useState(false);

  const handleOnChangeTabs = (events, updatedTabValue) => {
    setActiveTabs(updatedTabValue);
  };

  const handleCountUpdate = (locationListCount, totalPageCount) => {
    setLocationCount(locationListCount);
    setTotalPage(totalPageCount);
  };

  const selectedTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <LocationRepositoryBody
            query={searchText}
            pageSize={pageSize}
            currentPage={page + 1}
            onCountUpdate={handleCountUpdate}
          />
        );
      default:
        return (
          <LocationRepositoryBody
            query={searchText}
            pageSize={pageSize}
            currentPage={page + 1}
            onCountUpdate={handleCountUpdate}
          />
        );
    }
  };
  return (
    <>
      <div style={{ display: "flex" }}>
        <LocationRepositoryTabs
          activeTabValue={activeTab}
          handleOnChangeTabs={handleOnChangeTabs}
          count={loactionCount}
        />
        <div style={{ display: "flex", marginTop: "5px" }}>
          <CommonSearchFiled
            label={StringUtils.search}
            onSearch={(text) => {
              setSearchText(text);
            }}
            onClear={() => {
              setSearchText("");
            }}
            width="300px"
            borderRadius="8px"
          />
        </div>
      </div>
      {selectedTabContent()}

      {loactionCount !== 0 && (
        <div  style={{marginLeft: "15px",marginTop:"10px",...footerStyles}}>
          <MyPagination
            currentPage={page + 1}
            totalPages={totalPages}
            onPageChange={setPage}
            rowsPerPage={pageSize}
            onRowsPerPageChange={setPageSize}
            totalEntries={loactionCount}
            setIsStart={setIsStart}
            marginRight={localStorage.getItem('isFromHostApplication') ? "11rem" : "5px"}
          />
        </div>
      )}
    </>
  );
};

export default LocationRepositoryPage;
